import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

function initSliders() {
    Swiper.use([Navigation, Pagination]);
    const $wrappers = document.querySelectorAll('.js-blockSliderWrapper');

    if (!$wrappers || !$wrappers.length) return;

    $wrappers.forEach(function($wrapper) {
        const $swiper = $wrapper.querySelector('.TextSlider-content');
        if (!$swiper) {
            return;
        }

        const $sliderTitle = $wrapper.querySelector('.js-textSliderTitle');
        const $sliderCounter = $wrapper.querySelector('.js-textSliderCounter');

        function updateSlidesCounter(swiper) {
            let $activeEl;

            setTimeout(function() {
                swiper.slides.forEach(($item, idx) => {
                    if ($item.classList.contains('swiper-slide-active')) {
                        $activeEl = $item;

                        if ($sliderCounter) {
                            $sliderCounter.textContent = `${(idx + 1)} из ${swiper.slides.length}`
                        }
                    }
                });

                if (!$activeEl) {
                    return;
                }

                if ($sliderTitle) {
                    $sliderTitle.classList.add('is-visible');
                    if ($activeEl.dataset.description) {
                        $sliderTitle.textContent = $activeEl.dataset.description;
                    } else if ($activeEl.getAttribute('aria-description')) {
                        $sliderTitle.textContent = $activeEl.getAttribute('aria-description');
                    } else {
                        $sliderTitle.classList.remove('is-visible');
                    }
                }
            }, 250)
        }

        let options = {
            on: {
                init: updateSlidesCounter,
                slideChange: updateSlidesCounter,
            },
        };
        let $pagination = $wrapper.querySelector('.swiper-pagination');
        if ($pagination) {
            options.pagination = {
                el: $pagination,
                currentClass: 'current',
                hiddenClass: 'hidden',
                lockClass: 'lock',
                totalClass: 'total',
                clickableClass: 'clickable',
                dynamicBullets: true,
                dynamicMainBullets: 1,
                clickable: true,
            }
        }

        if ($wrapper && $wrapper.querySelector('.js-arrowNext')
            && $wrapper.querySelector('.js-arrowPrev')) {
            options.navigation = {
                nextEl: $wrapper.querySelector('.js-arrowNext'),
                prevEl: $wrapper.querySelector('.js-arrowPrev'),
            }
        }

        new Swiper($swiper, options);
    });
}

initSliders();
